module.exports = __webpack_public_path__ + "static/media/fs-back-arrow-white_v2.7379ab98.png";